const supportedVideoTypes: string[] = [
    /* 'mov'? */
    /* 'mpeg'? */
    /* youtube/vimeo/twitch embed? */
    /* hls? */
    /* convert gif to video? */
    'mp4',
    'webm',
    'ogg'
];

const supportedImageTypes: string[] = [
    'jpg',
    'jpeg',
    'png',
    'svg',
    'gif' /* convert to video? */,
    'image/svg', // Data url (webpack svg imports)
    'image/svg+xml' // Data url (webpack svg imports)
];

export default {
    supportedVideoTypes,
    supportedImageTypes
};
